export function stopPropagate<T>(callback: (e: T) => void) {
  return (e: T & { stopPropagation: () => void }) => {
    e.stopPropagation()
    callback(e)
  }
}
